export default "__VITE_ASSET__Dq7kCjAy__"